import React from "react"
import Alert from "react-bootstrap/Alert"
import { useTranslation } from "react-i18next"

/**
 * Shows an bootstrap "danger" error alert - if error is truthy.
 * Overwrite error message to display with children.
 */
export const ErrorAlert: React.FunctionComponent<{ error?: any }> = ({
    children,
    error,
}) => {
    const i18n = useTranslation()

    if (error && Object.getOwnPropertyNames(error).length != 0) {
        const unpackedError = error?.body?.message || error?.body || error
        const displayMessage = i18n.t(children || unpackedError)

        return (
            <Alert
                variant="danger"
                ref={(node) =>
                    node ? (node.innerText = displayMessage) : void 0
                }
            />
        )
    }

    return null
}
